import { render, staticRenderFns } from "./conversionMarket.vue?vue&type=template&id=38024c5d&scoped=true"
import script from "./conversionMarket.vue?vue&type=script&lang=js"
export * from "./conversionMarket.vue?vue&type=script&lang=js"
import style0 from "./conversionMarket.vue?vue&type=style&index=0&id=38024c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38024c5d",
  null
  
)

export default component.exports